<template>
    <form @submit.prevent="makePayment" :disabled="loading">
        <div class="modal fade show" style="display: block" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{translate('paymentModal.payment')}}</h5>
                <button type="button" class="close" data-dismiss="modal" :aria-label="translate('close')" @click="close()">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" style="height:500px; overflow-y: auto;">
                <div class="col-12">
                    <div class="form-group row">
                        <div class="col">
                            <table class="table table-borderless table-sm">
                                <tbody>
                                    <tr>
                                        <td>{{translate('paymentModal.tariffToRenew')}}</td>
                                        <td>:</td>
                                        <td>{{this.data.uetsPriceResponse[0].name}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{translate('paymentModal.price')}}</td>
                                        <td>:</td>
                                        <td>{{this.data.uetsPriceResponse[0].price}} ₺</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col">
                            <table class="table table-borderless table-sm">
                                <tbody>
                                    <tr>
                                        <td>{{translate('paymentModal.tariffToBuy')}}</td>
                                        <td>:</td>
                                        <td>{{this.data.uetsPriceResponse[0].name}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{translate('paymentModal.price')}}</td>
                                        <td>:</td>
                                        <td>{{this.data.uetsPriceResponse[0].price}} ₺</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
              </div> 
            </div>
            <div class="modal-footer footer-button-container"> 
                <button type="button"  class="btn btn-secondary" @click="close()" data-dismiss="modal">
                    {{translate('close')}}
                </button>
                <button type="submit"  class="btn btn-success">
                    {{translate('makePayment')}}
                </button>
            </div>
            </div>
        </div>
        </div>
    </form>
</template>


<script>
import formMixin from "../formMixin.js";

export default {
    mixins: [formMixin],
    components: {
    },
    created() {
        this.data = Object.assign({}, this.model);
    }, 
    props: {
          value : Object,
          model: Object,
      },
    data() {
        return {
            loading: false, 
            data: {}
        };
    },
    methods: {
        makePayment(){
            alert(this.translate('messages.paymentDone'))
            this.$emit('close');
            this.$emit('paymentSuccess', true);
        },
        updateInvoiceInfo(){
            this.$emit('updateInvoiceInfo', true)
        },
        close(){
            this.$emit('close');
        }
    },
};
</script>
